import { AuctionState } from "@/src/types/types";

export interface CardTypeFlags {
  isWarningCard: boolean;
  isFinalOfferCard: boolean;
  isSuccessCard: boolean;
  isNotSoldCard: boolean;
}

export const isSuccessState = (state: AuctionState): boolean =>
  state === AuctionState.OFFER_ACCEPTED ||
  state === AuctionState.SOLD ||
  state === AuctionState.SENT_FOR_BILLING ||
  state === AuctionState.BILLED;

export const isWarningState = (
  state: AuctionState,
  hasPendingOffer: boolean
): boolean =>
  state === AuctionState.DRAFT ||
  (state === AuctionState.ENDED && hasPendingOffer);

export const isSoldState = (state: AuctionState): boolean =>
  state === AuctionState.SOLD ||
  state === AuctionState.SENT_FOR_BILLING ||
  state === AuctionState.BILLED;
